import { render, staticRenderFns } from "./add-new-form.vue?vue&type=template&id=ad3bcdba"
import script from "./add-new-form.vue?vue&type=script&lang=js"
export * from "./add-new-form.vue?vue&type=script&lang=js"
import style0 from "./add-new-form.vue?vue&type=style&index=0&id=ad3bcdba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports